const isProduction = process.env.NODE_ENV === 'production';
const isDev = process.env.NODE_ENV === 'development';
//  const proUrl = 'http://emergencyai.web.shuzhiren.com'
//  const proUrl = 'http://test.ever.ai.guanyingis.com'
// const proUrl = 'http://air3.shuzhiren.com:32184'; //
 const proUrl = '/wapi'

// 开发环境使用空字符串，让代理生效；生产环境使用实际地址
export const baseUrl = isDev ? '' : proUrl;

// 文件上传地址
export const uploadUrl = `${isProduction ? baseUrl : ''}/api/common/uploadFileToLocal`;
